import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET paginated notifications
export const getNotifications = async ({ page = 1, pageSize = 10, search = '' } = {}) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/notifications`, {      params: { page, pageSize, search },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching notifications:", error.response?.data || error);
    throw error;
  }
};

// GET a single notification
export const getNotificationById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/notifications/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching notification:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new notification
export const createNotification = async (notificationData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/notifications`, notificationData);
    return response.data;
  } catch (error) {
    console.error("Error creating notification:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing notification
export const updateNotification = async (id, notificationData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/notifications/${id}`, notificationData);
    return response.data;
  } catch (error) {
    console.error("Error updating notification:", error.response?.data || error);
    throw error;
  }
};

// DELETE a notification
export const deleteNotification = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/notifications/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting notification:", error.response?.data || error);
    throw error;
  }
};

// GET notification counts by priority (open only)
export const getNotificationPrioritySummary = async () => {
  const response = await axiosInstance.get(`${API_URL}/notifications/priority-summary`);
  return response.data;
};

// GET open and closed notifications by day for last 30 days
export const getNotificationsOpenedClosed = async () => {
  const response = await axiosInstance.get(`${API_URL}/notifications/daily-open-closed`);
  return response.data;
};

// GET outstanding notifications by day for last 30 days
export const getOutstandingNotificationsByDay = async () => {
  const response = await axiosInstance.get(`${API_URL}/notifications/outstanding-by-day`);
  return response.data;
};
